import { saveAs } from 'file-saver';
import Excel from 'exceljs';
import { customerListXLS } from './xlsColumns';
import { currentDateFormatted } from '../constants/date-values';
import { NameIdDto } from '../api/api-types';

export const exportCustomerList = async (customerList: NameIdDto[]) => {
  const workbook = new Excel.Workbook();
  try {
    const fileName = `Customer list ${currentDateFormatted}`;

    const worksheet = workbook.addWorksheet('Clients');

    worksheet.columns = customerListXLS;

    worksheet.getRow(1).eachCell((cell) => {
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'A6CCF7' },
      };
      cell.font = { bold: true };
    });

    customerList.map((item) =>
      worksheet.addRow({
        customer: item.name,
      }),
    );

    worksheet.columns.forEach((column) => {
      let maxLength = 0;
      if (column.eachCell) {
        column.eachCell({ includeEmpty: true }, (cell) => {
          const columnLength = cell.value ? cell.value.toString().length : 72;
          if (columnLength > maxLength) {
            maxLength = columnLength;
          }
          cell.border = {
            top: { style: 'thin' },
            left: { style: 'thin' },
            bottom: { style: 'thin' },
            right: { style: 'thin' },
          };
        });
      }
      column.width = maxLength > 72 ? 72 : maxLength;
      column.alignment = {
        vertical: 'middle',
        horizontal: 'left',
        wrapText: true,
      };
    });

    const buf = await workbook.xlsx.writeBuffer();

    saveAs(new Blob([buf]), `${fileName}.xlsx`);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  } catch (error: any) {
    return error.message;
  } finally {
    workbook.removeWorksheet('Clients');
  }
};
